export default __webpack_public_path__ + "static/media/magnifier-outline.4d8e5756.svg";